module.exports = __webpack_public_path__ + "static/img/logo8.be5869b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo8.jpg
// module id = 9d7i
// module chunks = 2